<template>
  <div class="invader" ref="wrapper">
    <div class="invader__container" :class="cssClass" :style="cssVars" ref="invader">
      <alive v-if="!isPaused || !showDeadWhenPaused" class="invader__sliding" :fill="fill" />
      <dead v-else />
    </div>
  </div>
</template>

<script>
import Alive from "./Invaders/Alive.vue";
import Dead from "./Invaders/Dead.vue";

export default {
  name: "Invader",
  components: {
    Alive,
    Dead
  },
  props: {
    speed: {
      type: Number,
      required: true
    },
    loops: {
      type: [String, Number],
      validator: prop => prop === "infinite" || typeof prop === "number",
      default: "infinite"
    },
    isPaused: {
      type: Boolean,
      required: true
    },
    fill: {
      type: String,
      default: "#ab90c9"
    },
    showDeadWhenPaused: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      invaderWidth: 0,
      containerWidth: 0,
      originalInvader: "../assets/icons/invader.svg",
      isAnimating: false
    };
  },
  mounted() {
    this.updateInvaderWidth();
    this.updateContainerWidth();

    window.addEventListener("resize", this.updateContainerWidth);

    setTimeout(() => {
      this.isAnimating = true;
    }, 500);
  },
  computed: {
    cssVars() {
      return {
        "--max-translation": `${(this.containerWidth - this.invaderWidth) *
          0.5}px`,
        "--min-translation": `${(this.containerWidth - this.invaderWidth) *
          -0.5}px`,
        "--speed": `${this.speed}s`,
        "animation-iteration-count": this.loops
      };
    },
    cssClass() {
      return {
        animate: this.isAnimating,
        paused: this.isAnimating && this.isPaused
      };
    },
    invader() {
      return this.originalInvader;
    }
  },
  methods: {
    updateInvaderWidth() {
      this.invaderWidth = this.$refs.invader.clientWidth;
    },
    updateContainerWidth() {
      this.containerWidth = this.$refs.wrapper.clientWidth;
    }
  }
};
</script>

<style lang="scss" scoped>
.invader {
  display: block;
  margin: 0 15px;
  text-align: center;

  .invader__container {
    display: inline-block;
    margin: 0 auto;
    animation-fill-mode: forwards;
    transform: translateX(0);
    -webkit-transform: translateX(0);
    &.animate {
      animation-name: invaderAnimation;
      animation-duration: var(--speed);
      animation-iteration-count: infinite;
      animation-timing-function: ease;
      animation-play-state: running;
    }

    &.paused {
      animation-play-state: paused;
    }
  }
}

@keyframes invaderAnimation {
  0% {
    transform: translateX(-1px);
    -webkit-transform: translateX(-1px);
  }

  25% {
    transform: translateX(var(--min-translation));
    -webkit-transform: translateX(var(--min-translation));
  }

  75% {
    transform: translateX(var(--max-translation));
    -webkit-transform: translateX(var(--max-translation));
  }

  99% {
    transform: translateX(1px);
    -webkit-transform: translateX(1px);
  }
}
</style>